const gmCloseButtons = document.querySelectorAll('.close-popup');
gmCloseButtons.forEach((el) =>
    el.addEventListener('click', (event) => {
        el.closest('.popup').classList.remove('popup--visible');
    })
);

function gmOn(eventType, selector, callback) {
    document
        .querySelector('.main-content')
        .addEventListener(eventType, function (event) {
            if (event.target.matches(selector)) {
                callback.call(event.target);
            } else {
                var sortingEl = document.querySelector(
                    '.product-sorting__list'
                );

                if (sortingEl !== null) {
                    sortingEl.classList.remove(
                        'product-sorting__list--expanded'
                    );
                }
            }
        });
}
if (
    document.querySelector('#search-result') &&
    document.querySelector('.product-sorting__list')
)
    gmOn('click', '.product-sorting__list-item', function () {
        if (this.classList.contains('product-sorting__list-item--active'))
            this.closest('.product-sorting__list').classList.toggle(
                'product-sorting__list--open'
            );
        else window.location = this.dataset.value;
    });

if (
    document.querySelector('.sub-categories--slider') &&
    document.querySelector('.sub-categories__items')
) {
    const slider = tns({
        container: '.sub-categories--slider .sub-categories__items',
        autoWidth: true,
        loop: false,
        mouseDrag: true,
        prevButton: '.sub-categories__prev',
        nextButton: '.sub-categories__next',
        swipeAngle: false,
        speed: 400,
        nav: false,
    });
}
if (document.querySelector('#load-more-button')) {
    if (localStorage.getItem('lazyInfo') && window.history.state == 'search') {
        window.history.scrollRestoration = 'manual';
    } else {
        window.history.scrollRestoration = 'auto';
    }
}
